module.exports = __webpack_public_path__ + "static/media/card.6ccb9956.svg";